import { Col, Row } from 'reactstrap';
import { PageContainer } from '../../style/Containers.style';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import React from 'react';
import { updateServiceWorkAndRefresh } from 'lib/registerServiceWorker';

/**
 * Handles the errors in lazy loading components.
 * If the error is dur to loading chunks it attempts to refresh.
 * @param {string} error
 * @param {Function} t Translation function
 * @returns {string} Translated template string.
 */
const handleComponentError = (error, t) => {
  Raven.captureException(error);

  if (['local', 'development'].includes(process.env.NODE_ENV)) {
    // Log errors to console for easier debugging in local and dev environments.
    /* eslint no-console: 0 */
    console.error(error);
  }

  if (/Error: Loading chunk/.test(error)) {
    // Happens if the page has not been refreshed since the last deploy.
    updateServiceWorkAndRefresh();
  }
  // Always present the user with an error, even if we expect to navigate away immediately.
  return t(
    'You have encountered an error and the requested page cannot be displayed. Please try again.'
  );
};

const LoadingComponent = ({ isLoading, error }, { t }) => (
  <PageContainer>
    <Row>
      <Col>
        <p>{isLoading ? t('Loading...') : handleComponentError(error, t)}</p>
      </Col>
    </Row>
  </PageContainer>
);

LoadingComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/components/common/Loading/LoadingComponent.js